// Applies shake animation, and error class. Intended to be used with dom input elements
export function applyInputErrorStyling(...elements) {
	elements.forEach((el) => {
		el.classList.add("apply-shake");
		el.classList.add("input-error");
	});
}

// Removes error styling applied by the above function
export function removeInputErrorStyling(...elements) {
	elements.forEach((el) => {
		el.classList.remove("apply-shake");
		el.classList.remove("input-error");
	});
}
